import React from 'react';

import PropTypes from 'prop-types';

import { Badge } from 'apps/auth/components/common/Badge/Badge';
import { DiskBadge } from 'apps/auth/components/common/DiskBadge/DiskBadge';
import { Panel } from 'apps/auth/components/common/Panel/Panel';
import { DiskBadgeWrapper, PanelContent, PanelFrame, PanelRightBlock, SelectedDiskBadge } from 'apps/auth/components/common/Panel/styles';
import { Text } from 'apps/auth/components/common/Text/Text';
import { ACCOUNT } from 'apps/auth/constants/Constants';
import { getBankAlias, isCardExpired } from 'apps/auth/helpers/utils';
import { usePageMessages } from 'apps/auth/hooks/selectors';

import ActionBanner from './ActionBanner';

const SourcesList = (props) => {
    const { source, badge = '', popupRef } = props;
    const isExpired = isCardExpired(source);

    const { dcSourceExpired } = usePageMessages();

    return (
        <Panel
            onClick={(e) => {
                if (isExpired) {
                    props.onExpiredCardClick(e);
                } else if (props.actionBanner && !isExpired) {
                    popupRef?.current?.open(<ActionBanner actionBanner={props.actionBanner} popupRef={popupRef} handleClick={props.onClick} />);
                } else {
                    props.onClick(e);
                }
            }}
            negativeMargin
            isHoverable
        >
            <PanelFrame>
                <DiskBadgeWrapper>
                    {getBankAlias(source.cardLogo, source.type === ACCOUNT ? 'bank' : 'card', isExpired)}
                    {props.isSelected && (
                        <SelectedDiskBadge>
                            <DiskBadge variant="selectedPassive" iconName="check" />
                        </SelectedDiskBadge>
                    )}
                </DiskBadgeWrapper>
                <PanelContent>
                    <Text color={isExpired ? 'lightGray' : 'primary'}>{`${source.alias} ·· ${source.description}`}</Text>
                </PanelContent>
                <PanelRightBlock>
                    {isExpired || badge ? <Badge variant={isExpired ? 'tertiary' : 'primary'} caption={isExpired ? dcSourceExpired : badge} /> : null}
                </PanelRightBlock>
            </PanelFrame>
        </Panel>
    );
};
SourcesList.propTypes = {
    badge: PropTypes.string,
    actionBanner: PropTypes.string,
    popupRef: PropTypes.shape({ current: PropTypes.object }),
};

export default SourcesList;
